class ComparisonSlider {
  constructor(slider) {
    this.slider = slider;
    this.sliderHandle = slider.querySelector(".slider-handle");
    this.beforeImage = slider.querySelector(".before-image");
    this.isDragging = false;

    // Ensure transitions initially
    this.sliderHandle.style.transition =
      "left 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
    this.beforeImage.style.transition =
      "clip-path 0.3s cubic-bezier(0.4, 0, 0.2, 1)";

    // Create divider if not present
    if (!this.slider.querySelector(".divider")) {
      const d = document.createElement("div");
      d.className = "divider";
      this.slider.appendChild(d);
    }
    this.divider = this.slider.querySelector(".divider");
    // keep the divider transitions in sync with others
    this.divider.style.transition = "left 0.3s cubic-bezier(0.4, 0, 0.2, 1)";

    this.init();
  }

  init() {
    // Set initial position to 50%
    this.setPosition(50);

    // Add event listeners
    this.sliderHandle.addEventListener("mousedown", this.startDragging.bind(this));
    this.sliderHandle.addEventListener("touchstart", this.startDragging.bind(this), {passive:false});
    document.addEventListener("mousemove", this.drag.bind(this));
    document.addEventListener("touchmove", this.drag.bind(this), {passive:false});
    document.addEventListener("mouseup", this.stopDragging.bind(this));
    document.addEventListener("touchend", this.stopDragging.bind(this));

    // Click on slider jump
    this.slider.addEventListener("click", this.handleClick.bind(this));
    // Reset to center when clicking outside
    // document.addEventListener("click", this.handleOutsideClick.bind(this));
    // Optional: handle window resize so left stays consistent
    window.addEventListener("resize", () => {
      // recompute position based on current handle left
      const left = parseFloat(this.sliderHandle.style.left) || 50;
      this.setPosition(left);
    });
  }

  startDragging(e) {
    this.isDragging = true;
    this.slider.classList.add("dragging");

    // Remove transitions while dragging for immediate follow
    this.sliderHandle.style.transition = "none";
    this.beforeImage.style.transition = "none";
    this.divider.style.transition = "none";

    if (e.type === "touchstart") e.preventDefault();
  }

  stopDragging() {
    this.isDragging = false;
    this.slider.classList.remove("dragging");

    // Restore transitions after drag
    this.sliderHandle.style.transition =
      "left 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
    this.beforeImage.style.transition =
      "clip-path 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
    this.divider.style.transition = "left 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
  }

  drag(e) {
    if (!this.isDragging) return;
    e.preventDefault();

    const sliderRect = this.slider.getBoundingClientRect();
    const x = e.type === "touchmove" ? e.touches[0].clientX : e.clientX;
    let position = ((x - sliderRect.left) / sliderRect.width) * 100;
    position = Math.max(0, Math.min(100, position));
    this.setPosition(position);
  }

  handleClick(e) {
    const sliderRect = this.slider.getBoundingClientRect();
    const position = ((e.clientX - sliderRect.left) / sliderRect.width) * 100;
    this.setPosition(position);
  }

  // handleOutsideClick(e) {
  //   if (!this.slider.contains(e.target)) {
  //     this.setPosition(50);
  //   }
  // }

  setPosition(position) {
    // move handle
    this.sliderHandle.style.left = `${position}%`;

    // update before image clip
    this.beforeImage.style.clipPath = `inset(0 ${100 - position}% 0 0)`;

    // move divider (align center of divider with handle)
    // using left + translateX(-50%) from CSS keeps it centered
    this.divider.style.left = `${position}%`;
  }
}

// Initialize all sliders
document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".comparison-slider");
  sliders.forEach((slider) => new ComparisonSlider(slider));
});
